export const resolveImagePath = (path: string | undefined) =>
  `${import.meta.env.VITE_BASE_URL}${path}`;
